import { downloadFile } from "actions/file";
import SageButton from "kit/SageButton";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import downloadFileStatusSelector from "selectors/downloadFileStatus";

interface Props {
    file: sage.model.IFile;
}

const FileListRow: React.FC<Props> = ({ file }) => {
    const dispatch = useDispatch();

    const createdAt = moment(new Date(file.created_at)).fromNow();

    const onDownload = React.useCallback(() => {
        dispatch(downloadFile(file.id));
    }, [dispatch, file.id]);

    const downloadFileStatus = useSelector(downloadFileStatusSelector(file.id));

    return (
        <div className="list-group-item">
            <div className="d-flex align-items-center justify-content-between">
                <h5>{file.friendly_name || "Unnamed File"}</h5>
            </div>
            <p>Created {createdAt}</p>
            <div className="btn-group" role="group">
                <Link
                    type="button"
                    className="btn btn-secondary btn-sm"
                    to={`/home/files/create-job/${file.id}`}
                >
                    Create Job
                </Link>
                <SageButton
                    loading={downloadFileStatus === "loading"}
                    className="btn-sm"
                    theme="btn-secondary"
                    text="Download"
                    onClick={onDownload}
                />
            </div>
            <div>
                {status === "error" && (
                    <small className="text-danger">
                        An error occurred. Please try again.
                    </small>
                )}
            </div>
        </div>
    );
};

export default FileListRow;
